import { useEffect, useRef } from 'react';
import openModal from '@/modals/utils/openModal';
import { shouldShowRestrictedGamePromoOnlyPopup } from '../_utils/gameLaunchBalanceGate';

type UseRestrictedGamePromoOnlyPopupParams = {
  gameId: string;
  isGameSessionActive: boolean;
  currency: string;
  sweepCoin?: number | null;
  bonusSweepCoin?: number | null;
  isBonusAllowed?: boolean;
};

export function useRestrictedGamePromoOnlyPopup({
  gameId,
  isGameSessionActive,
  currency,
  sweepCoin,
  bonusSweepCoin,
  isBonusAllowed,
}: UseRestrictedGamePromoOnlyPopupParams) {
  const hasShownPromoOnlyPopupRef = useRef(false);

  useEffect(() => {
    hasShownPromoOnlyPopupRef.current = false;
  }, [gameId, isGameSessionActive]);

  useEffect(() => {
    const shouldShowPromoOnlyPopup = shouldShowRestrictedGamePromoOnlyPopup({
      isGameSessionActive,
      currency,
      sweepCoin,
      bonusSweepCoin,
      isBonusAllowed,
    });

    if (!shouldShowPromoOnlyPopup) {
      hasShownPromoOnlyPopupRef.current = false;
      return;
    }

    if (hasShownPromoOnlyPopupRef.current) {
      return;
    }

    hasShownPromoOnlyPopupRef.current = true;
    openModal('disallow-game-by-category');
  }, [
    isGameSessionActive,
    currency,
    sweepCoin,
    bonusSweepCoin,
    isBonusAllowed,
  ]);
}
